const GoalCategory = Object.freeze({
    CVD: 0,
    CANCER: 1,
    METABOLIC: 2,
    NEURO: 3,
    OTHER: 4
})

export default GoalCategory